<template>
	<div>
		<div>
			<router-view />
		</div>
	</div>
</template>
<script>
import { getToken } from '@/utils/infomationStorage.js';
import { mapMutations, mapState } from 'vuex';
export default {
	name: '',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {
			showViewFlag: true, //权限
			viewMessage: '无权限', //权限提示
		};
	},
	computed: {
		...mapState(['userToken']),
	},

	watch: {
		userToken(newUid, oldUid) {
			// ////console.log(newUid);
			// this.getAccess();
		},
	},
	created() {
		// this.$nextTick(() => {
		// 	this.getAccess();
		// });
	},
	mounted() {
		// ////console.log(!getToken());
		// ////console.log(this.$router.history.pending.path);
		// ////console.log(this.$router.history.pending.path);
		// ////console.log(this.$router.history.pending.path !== '/' && !getToken());
		if (this.$router.history.pending.path !== '/' && !getToken()) {
			this.showViewFlag = false;
			this.viewMessage = '请登录';
		} else {
			// this.getAccess();
		}
	},
	methods: {
		getAccess() {
			let _this = this;
			// let projectName = process.argv.slice(0)[3].replace('--', '');
			// ////console.log(process.env.PROJECT_ADDRESS);

			$.ajax({
				url: `${
					process.env.PROJECT_ADDRESS
				}/reportapi/CommonController/common/checkUrlRight?token=${getToken()}`,
				//查询用户是否有权限
				dataType: 'json',
				// jsonpCallback: 'showData', //指定回调函数名称
				// xhrFields: { withCredentials: true },
				crossDomain: true,
				async: true,
				success: function (data) {
					////console.log(data);
					//code -1是未登录
					//0是登录有权限
					//-2是没权限
					// ////console.log(_this.$router.history.current);
					//如果是首页就不用判断有没有权限
					if (_this.$router.history.current.path == '/') {
						_this.showViewFlag = true;
					} else {
						let descCode = data.code;
						if (descCode == 0 || descCode == '0') {
							_this.showViewFlag = true;
						} else if (descCode == -1 || descCode == '-1') {
							_this.showViewFlag = false;
							_this.viewMessage = '请登录';
						} else {
							_this.showViewFlag = false;
							_this.viewMessage = data.message;
						}
					}
				},
			});
		},
		back() {
			// 获取历史记录中的页面数量
			const historyLength = window.history.length;

			// 如果页面数量大于 1，则表示有上一页可返回
			if (historyLength > 1) {
				// window.location.href = 'http://www.drcnet.com.cn';
				window.history.back(); // 返回上一页
			} else {
				// 没有上一页可返回，可能是第一个页面，也可能是浏览器不支持历史记录
				// 这里可以做一些其他处理，比如跳转到首页或者其他页面
				//跳转到国研网首页
				window.location.href = 'http://www.drcnet.com.cn';
			}
		},
	},
};
</script>
<style lang="less" scoped>
.noView {
	background: #eff1f3;
	height: 100%;
	width: 100%;
	position: absolute;
	.noViewNav {
		width: 100%;
		height: 70px;
		background: #0065cc;
		border: 1px solid #e2e3e4;
		display: flex;
		justify-content: center;
		align-items: center;
		.noViewNavIcon {
			width: 1200px;
			text-align: left;
			img {
				cursor: pointer;
			}
		}
	}
	.noViewContent {
		display: flex;
		justify-content: center;
		.noViewContentBlock {
			text-align: center;
			margin-top: 56px;
			width: 1200px;
			height: 735px;
			background: #ffffff;
			box-shadow: 0px 5px 49px 0px rgba(239, 241, 243, 0.75);
			border-radius: 5px;
			.authorityImg {
				margin-top: 60px;
			}
			.authorityMessage {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 26px;
				color: #333333;
				line-height: 48px;
			}
			.authorityPhone {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 19px;
				color: #333333;
				line-height: 36px;
			}
			.authorityEmail {
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 19px;
				color: #333333;
				line-height: 36px;
				.emailtext {
					color: #0065cc;
				}
			}
			.authorityButton {
				width: 151px;
				height: 37px;
				margin-top: 40px;
				background: #1c86f1;
				border-radius: 19px;
				display: inline-block;
				font-family: Microsoft YaHei;
				font-weight: 400;
				font-size: 18px;
				color: #ffffff;
				line-height: 37px;
				cursor: pointer;
			}
		}
	}
}
</style>
